import BarChartImg from '../../../../../../img/components/Bar-chart.svg';
import DoughnutChartImg from '../../../../../../img/components/Doughnut-chart.svg';
import LineChartImg from '../../../../../../img/components/Line-chart.svg';
import PieChartImg from '../../../../../../img/components/Pie-chart.svg';
import PolarChartImg from '../../../../../../img/components/Polar-chart.svg';
import PreviewComponentLabel from '../../../../../ts/components/page-editor/components/preview/previewComponentLabel/PreviewComponentLabel';
import type { PageComponentName } from '../../../../types/pageEditor';
import { COMPONENT_TYPE } from '../../constants';
import BarChartStackedImg from '../../../../../../img/components/Bar-chart-stacked.svg';

interface BaseProps {
    isRequired: boolean;
    label: string;
    isStacked: boolean;
}

interface Props extends BaseProps {
    componentType: PageComponentName;
}

export const BarChartComponent = ({ isRequired, label, isStacked }: BaseProps) =>
    ChartComponent({ componentType: COMPONENT_TYPE['CHARTBAR'], isRequired, label, isStacked });
export const LineChartComponent = ({ isRequired, label, isStacked }: BaseProps) =>
    ChartComponent({ componentType: COMPONENT_TYPE['CHARTLINE'], isRequired, label, isStacked });
export const PieChartComponent = ({ isRequired, label, isStacked }: BaseProps) =>
    ChartComponent({ componentType: COMPONENT_TYPE['CHARTPIE'], isRequired, label, isStacked });
export const DoughnutChartComponent = ({ isRequired, label, isStacked }: BaseProps) =>
    ChartComponent({
        componentType: COMPONENT_TYPE['CHARTDOUGHNUT'],
        isRequired,
        label,
        isStacked,
    });
export const PolarChartComponent = ({ isRequired, label, isStacked }: BaseProps) =>
    ChartComponent({ componentType: COMPONENT_TYPE['CHARTPOLAR'], isRequired, label, isStacked });

const ChartComponent = ({ componentType, isRequired, label, isStacked }: Props) => {
    const type = {
        [COMPONENT_TYPE['CHARTBAR']]: isStacked ? BarChartStackedImg : BarChartImg,
        [COMPONENT_TYPE['CHARTLINE']]: LineChartImg,
        [COMPONENT_TYPE['CHARTPIE']]: PieChartImg,
        [COMPONENT_TYPE['CHARTDOUGHNUT']]: DoughnutChartImg,
        [COMPONENT_TYPE['CHARTPOLAR']]: PolarChartImg,
    };

    const src = type[componentType.toUpperCase()];

    return (
        <div data-testid="component-preview-chart">
            <PreviewComponentLabel labelText={label} isRequired={isRequired} />
            <div className="component-preview-image-container">
                <img
                    data-testid="component-preview-chart"
                    className="component-preview-image"
                    alt=""
                    src={src}
                />
            </div>
        </div>
    );
};

export default ChartComponent;
